export default __webpack_public_path__ + "static/media/img_health_tip@3x.ba9ebee2.png";